/* eslint-disable class-methods-use-this */
class VerticalSideNav extends HTMLElement {
  constructor() {
    super()
    this.init()
  }

  init() {
    this.addEventListener('click', function (e) {
      const link = e.target.closest('.vertical-side-nav__link')
      if (
        link &&
        link.getAttribute('href') &&
        link.getAttribute('href').startsWith('#')
      ) {
        const href = link.getAttribute('href')
        const target = document.getElementById(href.substring(1))
        if (target) {
          e.preventDefault()
          target.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }
    })

    // Hide/show nav on scroll
    const stickyNav = this.querySelector('.vertical-side-nav__sticky')
    if (!stickyNav) return
    let lastScrollY = window.scrollY
    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY
      if (currentScroll > 0) {
        stickyNav.classList.add('vertical-side-nav__desktop--hidden')
      } else {
        stickyNav.classList.remove('vertical-side-nav__desktop--hidden')
      }
      lastScrollY = currentScroll
    })
  }
}

function runVerticalSideNav() {
  if (customElements.get('vertical-side-nav')) return
  customElements.define('vertical-side-nav', VerticalSideNav)
}

runVerticalSideNav()
